import {ControlType} from '../app/forms/item/item.model';
import {TableFieldConditionArgumentOperator, TableFieldType} from '../app/forms/table-field/table-field.model';
import {ServiceAttachmentGroupType} from '../app/forms/forms.model';
import {AdminType} from '../app/users/users.model';
import {OrderState, ProductAttributeScope, ProductAttributeType} from '../app/master-data/master-data.model';
import {PermissionType} from '../app/forms-permissions/forms.model';

export const CONFIRM_DIALOG_CONFIRM_ACTION = 'Potwierdź działanie';
export const CONFIRM_DIALOG_MESSAGE = 'Wiadomość systemowa';
export const CONFIRM_DIALOG_MESSAGE_DELETE = 'Ten wpis nie może zostać usunięty z bazy danych. Proszę skotaktować się dostawcą systemu';
export const CONFIRM_DIALOG_STATUS_DELETE = 'Potwierdź usunięcie statusu';
export const CONFIRM_DIALOG_ALLOWED_STATUS_DELETE = 'Potwierdź usunięcie dozwolonego statusu';
export const CONFIRM_DIALOG_PRODUCT_CATEGORY_ATTRIB_DELETE = 'Potwierdź usunięcie atrybutu kategorii produktu';
export const CONFIRM_DIALOG_LIBRARY_DOC_DELETE = 'Potwierdź usunięcie pliku';
export const CONFIRM_DIALOG_LIBRARY_DIR_DELETE = 'Potwierdź usunięcie folderu';
export const CONFIRM_DIALOG_AREA_DELETE = 'Potwierdź usunięcie terytorium';
export const CONFIRM_DIALOG_FORM_WRONG_NAME = 'Taka nazwa już istnieje. Wybierz inną nazwę';
export const CONFIRM_DIALOG_FORM_DUPL_NAME = 'Taki tag już istnieje. Nadpisać';
export const SNACKBAR_LOGIN_ERROR = `Błędna nazwa użytkownika lub hasło `;
export const SNACKBAR_USER_ERROR = `Brak uprawnień do logowania`;
export const SNACKBAR_PASSWORD_RESET_SUCCESS = `Komenda zmiany hasła wysłana`;
export const SNACKBAR_PASSWORD_RESET_ERROR = `Błąd przy próbie zmiany hasła`;
export const SNACKBAR_BRANCH_ADD_SUCCESS = `Oddział dodany`;
export const SNACKBAR_BRANCH_ADD_ERROR = `Bład przy dodawaniu oddziału`;
export const SNACKBAR_BRANCH_CHANGE_SUCCESS = `Oddział zmieniony`;
export const SNACKBAR_BRANCH_CHANGE_ERROR = `Błąd przy zmianie oddziału`;
export const SNACKBAR_CHAIN_ADD_SUCCESS = `Sieć dodana`;
export const SNACKBAR_CHAIN_ADD_ERROR = `Bład przy dodawaniu sieci`;
export const CONFIRM_DIALOG_CUSTOMER_DELETE = 'Potwierdź usuniecie klienta';
export const SNACKBAR_FORM_ASSIGN_ERROR = `Błąd przy zapisie danych do bazy`;
export const SNACKBAR_FORM_ASSIGN_SUCCESS = `Formularz przypisany poprawnie`;
export const SNACKBAR_LIBRARY_DOC_UPLOAD_SUCCESS = `Dokument przesłany`;
export const SNACKBAR_LIBRARY_DOC_UPDATE_SUCCESS = `Dokument zaktualizowany`;
export const SNACKBAR_LIBRARY_DOC_SAVE_ERROR = `Błąd przy zapisie dokumentu`;

export const CONFIRM_DIALOG_FORM_SET_ACTIVE =
  "Czy chcesz aktywować ten formularz?";
export const CONFIRM_DIALOG_FORM_SET_INACTIVE =
  "Czy chcesz wyłączyć ten formularz? Formularz nie pojawi się na urządzeniach mobilnych";
export const CONFIRM_DIALOG_FORM_SET_ALL_OBJECT =
  "Czy chcesz przypisać ten formularz do wszystkich obiektów? Formularz będzie przypisany do wszystkich klientów, produktów, rodzajów zleceń, statusów itd.";
export const CONFIRM_DIALOG_FORM_SET_ALL_SELECTED_OBJ =
  "Czy chcesz przypisać ten formularz tylko do wybranych obiektów, takich jak klient, produkt, rodzaj, status zlecenia? ";

export const FormTargetTypes: Record<PermissionType, string> = {
  [PermissionType.STATUS]: "Status",
  [PermissionType.CUSTOMER]: "Klient",
  [PermissionType.INSTALLATION]: "Instalacje",
  [PermissionType.ORDER_TYPE]: "Typ zlecenia",
  [PermissionType.PRODUCT]: "Produkt",
  [PermissionType.PRODUCT_CATEGORY]: "Kategoria Produktu",
  [PermissionType.BRANCH]: "Oddział",
  [PermissionType.DEPARTMENT]: "Dział",
  [PermissionType.LANGUAGE]: "Język formularza",
};

export const InputTypes: Record<ControlType, string> = {
  [ControlType.TEXT]: 'tekstowe',
  [ControlType.BOOLEAN]: 'tak/nie',
  [ControlType.DECIMAL]: 'liczba dzisiętna',
  [ControlType.MULTI]: 'wybór wielokrotny (checkbox)',
  [ControlType.RADIO]: 'wybór (radio button)',
  [ControlType.INTEGER]: 'liczba całkowita',
  [ControlType.DEVICES]: 'lista urządzeń',
  [ControlType.DROPDOWN]: 'przycisk rozwijany',
  [ControlType.DATE]: 'data',
  [ControlType.DATETIME]: 'data czas',
  [ControlType.DATERANGE]: 'zakres dat',
  [ControlType.EXPRESSION]: 'formuła',
  [ControlType.CONDITION]: 'warunek',
};

// Material icon shown next to each type in the "Select Type" dropdown.
export const InputTypeIcons: Record<ControlType, string> = {
  [ControlType.TEXT]: 'short_text',
  [ControlType.BOOLEAN]: 'check_box',
  [ControlType.DECIMAL]: 'calculate',
  [ControlType.MULTI]: 'checklist',
  [ControlType.RADIO]: 'radio_button_checked',
  [ControlType.INTEGER]: 'numbers',
  [ControlType.DEVICES]: 'devices',
  [ControlType.DROPDOWN]: 'arrow_drop_down_circle',
  [ControlType.DATE]: 'event',
  [ControlType.DATETIME]: 'schedule',
  [ControlType.DATERANGE]: 'date_range',
  [ControlType.EXPRESSION]: 'functions',
  [ControlType.CONDITION]: 'call_split',
};

export const TableFieldTypes: Record<TableFieldType, string> = {
  [TableFieldType.TEXT]: 'tekstowe',
  [TableFieldType.BOOLEAN]: 'tak/nie',
  [TableFieldType.RADIO]: 'wybór (radio button)',
  [TableFieldType.DECIMAL]: 'liczba dzisiętna',
  [TableFieldType.INTEGER]: 'liczba całkowita',
  [TableFieldType.DROPDOWN]: 'wybór z listy',
  [TableFieldType.EXPRESSION]: 'formuła',
  [TableFieldType.DATE]: 'data',
  [TableFieldType.DATETIME]: 'data czas',
  [TableFieldType.DATERANGE]: 'zakres dat',
  [TableFieldType.CONDITION]: 'warunek'
};

// Material icon shown next to each type in the "Select Type" dropdown.
export const TableFieldTypeIcons: Record<TableFieldType, string> = {
  [TableFieldType.TEXT]: 'short_text',
  [TableFieldType.BOOLEAN]: 'check_box',
  [TableFieldType.RADIO]: 'radio_button_checked',
  [TableFieldType.DECIMAL]: 'calculate',
  [TableFieldType.INTEGER]: 'numbers',
  [TableFieldType.DROPDOWN]: 'arrow_drop_down_circle',
  [TableFieldType.EXPRESSION]: 'functions',
  [TableFieldType.DATE]: 'event',
  [TableFieldType.DATETIME]: 'schedule',
  [TableFieldType.DATERANGE]: 'date_range',
  [TableFieldType.CONDITION]: 'call_split'
};

export const TableFiledConditionOperatorsMap: Record<TableFieldConditionArgumentOperator, string> = {
  [TableFieldConditionArgumentOperator.EQ]: '==',
  [TableFieldConditionArgumentOperator.NEQ]: '!=',
  [TableFieldConditionArgumentOperator.GT]: '>',
  [TableFieldConditionArgumentOperator.GTE]:  '>=',
  [TableFieldConditionArgumentOperator.LW]:  '<',
  [TableFieldConditionArgumentOperator.LWE]:  '<='
};

export const FormAttachmentGroupTypes: Record<ServiceAttachmentGroupType, string> = {
  [ServiceAttachmentGroupType.REQUIRED_ONE]: 'Wymagany jeden',
  [ServiceAttachmentGroupType.REQUIRED_ONE_OR_MORE]: 'Wymagany jeden lub więcej',
  [ServiceAttachmentGroupType.REQUIRED_ALL]: 'Wymagane wszystkie',
  [ServiceAttachmentGroupType.ALL_OPTIONAL]:  'Wszystkie opcjonalne'
};

export const AdminTypes: Record<AdminType, string> = {
  [AdminType.BranchAdmin]: 'Administrator Oddziału ',
  [AdminType.ChainAdmin]: 'Opiekun Sieci'
};

export const ProductCategoriesAttributes: Record<ProductAttributeType, string> ={
  [ProductAttributeType.BOOLEAN]: 'Binarne',
  [ProductAttributeType.TEXT]: 'Tekstowe',
  [ProductAttributeType.INTEGER]: 'L. całkowita',
  [ProductAttributeType.DECIMAL]: 'L. dziesiętna',
  [ProductAttributeType.TIMESTAMP]: 'Znacznik czasu',
};

export const ProductAttributeScopes: Record<ProductAttributeScope, string> ={
  [ProductAttributeScope.PRODUCT]: 'Stały dla produktu',
  [ProductAttributeScope.DEVICE]: 'Edytowalny dla urządzenia',
};

export const ProductAttributeScopesShort: Record<ProductAttributeScope, string> ={
  [ProductAttributeScope.PRODUCT]: 'Produkt',
  [ProductAttributeScope.DEVICE]: 'Urządzenie',
};

export const OrderStates: Record<OrderState, string> ={
  [OrderState.NEW]: 'NOWY',
  [OrderState.PENDING]: 'W TRAKCIE',
  [OrderState.ASSIGNED]: 'PRZYDZIELONY',
  [OrderState.AT_WORK]: 'W PRACY',
  [OrderState.PAUSED]: 'PRZERWA W PRACY',
  [OrderState.STOPPED]: 'ZATRZYMANY',
  [OrderState.POSTPROCESSING]: 'POST PROCES',
  [OrderState.ENDED]: 'ZAKOŃCZONY',
};
export const PAGINATOR_ITEMS_PER_PAGE = 'Ilość na stronie';
export const PAGINATOR_NEXT_PAGE = 'Następna';
export const PAGINATOR_PREV_PAGE = 'Poprzednia';
